import { Box, HStack, VStack, Text, Icon, Link } from '@chakra-ui/react'
import { LuScale, LuFileText, LuChevronRight } from 'react-icons/lu'
import { Link as RouterLink } from 'react-router-dom'
import { LEGAL_DOCS, LEGAL_VERSION } from '../../config/legal'
import { useTranslation } from 'react-i18next'

/**
 * Profile panel giving authenticated users a permanent access point to the
 * legal documents (CGU, CGV, mentions légales, confidentialité). Mirrors the
 * card styling of the other profile panels.
 */
export default function LegalDocsPanel() {
  const { t } = useTranslation()
  const formattedVersion = (() => {
    try {
      return new Date(LEGAL_VERSION).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
    } catch {
      return LEGAL_VERSION
    }
  })()

  return (
    <Box bg="white" borderRadius="2xl" boxShadow="sm" borderWidth="1px" borderColor="gray.200" overflow="hidden">
      <HStack px={6} py={4} borderBottom="1px solid" borderColor="gray.100" spacing={3}>
        <Box w="36px" h="36px" borderRadius="lg" bg="purple.50" display="grid" sx={{ placeItems: 'center' }}>
          <Icon as={LuScale} boxSize={4.5} color="purple.600" />
        </Box>
        <VStack align="start" spacing={0}>
          <Text fontSize="sm" fontWeight="700" color="gray.800">{t('profile.legalDocs.title')}</Text>
          <Text fontSize="xs" color="gray.500">Version en vigueur du {formattedVersion}</Text>
        </VStack>
      </HStack>

      <VStack align="stretch" spacing={0} px={2} py={2}>
        {LEGAL_DOCS.map((d) => (
          <Link
            as={RouterLink}
            key={d.slug}
            to={`/legal/${d.slug}`}
            _hover={{ textDecoration: 'none', bg: 'gray.50' }}
            borderRadius="lg"
            px={4}
            py={3}
          >
            <HStack spacing={3}>
              <Icon as={LuFileText} color="purple.400" boxSize={4} />
              <Text fontSize="sm" color="gray.700" fontWeight="500">{d.label}</Text>
              <Icon as={LuChevronRight} color="gray.300" boxSize={4} ml="auto" />
            </HStack>
          </Link>
        ))}
      </VStack>
    </Box>
  )
}
